module.exports = __webpack_public_path__ + "static/media/report.d0609b3a.svg";